import { render, staticRenderFns } from "./ThemThongTinCanBoModal.vue?vue&type=template&id=5662240a&"
import script from "./ThemThongTinCanBoModal.vue?vue&type=script&lang=js&"
export * from "./ThemThongTinCanBoModal.vue?vue&type=script&lang=js&"
import style0 from "./ThemThongTinCanBoModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports